module.exports = __webpack_public_path__ + "static/resume-8b3cd5f0c5ce23b1251f2ba160f2ad34.pdf";